import {customElement, property} from 'lit/decorators.js';
import {html, LitElement} from 'lit';
import {style} from './headline-link.styles';
import './headline-link.scss'

@customElement('sbk-headline-link')
export class SbkHeadlineLink extends LitElement {

    @property({type: String})
    href = '';

    @property({type: Boolean, reflect: true})
    underlined = false;

    @property()
    variant: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' = 'md'

    static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

    static get styles() {
        return style;
    }

    render() {
        if (!this.href) {
            return html`<span role="button" class="${this.variant} ${this.underlined ? 'underlined' : ''}"><slot class="text"></slot></span>`;
        }
        return html`<a href=${this.href}
               class="${this.variant} ${this.underlined ? 'underlined' : ''}"
               part="link"><slot class="text"></slot></a>`;
    }
}
